import type { RefObject } from 'react';
import { findTransitionController } from '../../../../util/core-transition-component';
import type { PrimaryLinkRef } from '../../../atoms/primary-link/PrimaryLink.data';
import type { HeadingRef } from '../../../atoms/heading/Heading.data';

interface ButtonGridItemRefs {
  elementRef?: RefObject<HTMLElement | null>;
  labelRef?: RefObject<HeadingRef | null>;
  buttonsRef?: RefObject<Array<RefObject<PrimaryLinkRef | null>> | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { buttonsRef, labelRef }: ButtonGridItemRefs,
): void {
  const labelController = findTransitionController(labelRef);
  timeline.add(labelController?.getTimeline('in') as gsap.core.Timeline, 0);

  buttonsRef?.current?.forEach((itemRef, index) => {
    const itemController = findTransitionController(itemRef);
    if (itemController) {
      timeline.add(itemController.getTimeline('in') as gsap.core.Timeline, 0.1 + index * 0.1);
    }
  });
}
